var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAltersverifizierungIdCardFront = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 133,
    viewBox: "0 0 226 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_7586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 74,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 102.007C70.528 102.007 86.9299 85.6051 86.9299 65.3724C86.9299 45.1397 70.528 28.7379 50.2954 28.7379C30.0627 28.7379 13.6609 45.1397 13.6609 65.3724C13.6609 85.6051 30.0627 102.007 50.2954 102.007Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_7586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 102.007C70.528 102.007 86.9299 85.6051 86.9299 65.3724C86.9299 45.1397 70.528 28.7379 50.2954 28.7379C30.0627 28.7379 13.6609 45.1397 13.6609 65.3724C13.6609 85.6051 30.0627 102.007 50.2954 102.007Z",
    fill: "#061437",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 73.4816C59.4633 73.4816 66.8954 66.0495 66.8954 56.8816C66.8954 47.7137 59.4633 40.2816 50.2954 40.2816C41.1274 40.2816 33.6954 47.7137 33.6954 56.8816C33.6954 66.0495 41.1274 73.4816 50.2954 73.4816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 134.757C66.3392 134.757 79.3454 121.751 79.3454 105.707C79.3454 89.6632 66.3392 76.6571 50.2954 76.6571C34.2515 76.6571 21.2454 89.6632 21.2454 105.707C21.2454 121.751 34.2515 134.757 50.2954 134.757Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_707_7586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 74,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2954 102.007C70.528 102.007 86.9299 85.6051 86.9299 65.3724C86.9299 45.1397 70.528 28.7379 50.2954 28.7379C30.0627 28.7379 13.6609 45.1397 13.6609 65.3724C13.6609 85.6051 30.0627 102.007 50.2954 102.007Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_707_7586)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.984 23.5862H108.526C107.39 23.5862 106.469 24.5072 106.469 25.6433V31.8325C106.469 32.9686 107.39 33.8896 108.526 33.8896H187.984C189.12 33.8896 190.041 32.9686 190.041 31.8325V25.6433C190.041 24.5072 189.12 23.5862 187.984 23.5862Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.179 79.1921H108.526C107.39 79.1921 106.469 80.1132 106.469 81.2493V83.0227C106.469 84.1588 107.39 85.0798 108.526 85.0798H144.179C145.315 85.0798 146.236 84.1588 146.236 83.0227V81.2493C146.236 80.1132 145.315 79.1921 144.179 79.1921Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.786 79.1921H163.133C161.997 79.1921 161.076 80.1132 161.076 81.2493V83.0227C161.076 84.1588 161.997 85.0798 163.133 85.0798H198.786C199.922 85.0798 200.843 84.1588 200.843 83.0227V81.2493C200.843 80.1132 199.922 79.1921 198.786 79.1921Z",
    fill: "#061437",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M208.591 43.0482H108.526C107.39 43.0482 106.469 43.9692 106.469 45.1054V51.2945C106.469 52.4307 107.39 53.3517 108.526 53.3517H208.591C209.727 53.3517 210.648 52.4307 210.648 51.2945V45.1054C210.648 43.9692 209.727 43.0482 208.591 43.0482Z",
    fill: "#061437",
    fillOpacity: 0.36
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M153.984 90.3134H108.526C107.39 90.3134 106.469 91.2344 106.469 92.3705V94.1439C106.469 95.28 107.39 96.201 108.526 96.201H153.984C155.12 96.201 156.041 95.28 156.041 94.1439V92.3705C156.041 91.2344 155.12 90.3134 153.984 90.3134Z",
    fill: "#061437",
    fillOpacity: 0.36
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M208.591 90.3134H163.133C161.997 90.3134 161.076 91.2344 161.076 92.3705V94.1439C161.076 95.28 161.997 96.201 163.133 96.201H208.591C209.727 96.201 210.648 95.28 210.648 94.1439V92.3705C210.648 91.2344 209.727 90.3134 208.591 90.3134Z",
    fill: "#061437",
    fillOpacity: 0.36
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAltersverifizierungIdCardFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/altersverifizierung-id-card-front.25eac7519d0748281e1392b9886ff2db.svg";